import React, { useContext } from 'react';
import { QueryClientContext, useQuery } from '@tanstack/react-query';
import api from '../../api/api';
import ContentTitle from './ContentTitle';

export function albumRatingRequest(item = {}) {
  const slug = item.albumSlug || item.slug;
  if (slug) return { path: `/albums/by-slug/${encodeURIComponent(slug)}` };
  const id = item.albumId ?? item.id;
  if (id != null) return { path: `/albums/${encodeURIComponent(id)}` };
  if (item.sourceId && item.albumSource)
    return { path: '/albums', params: { id: item.sourceId, type: item.albumSource } };
  return null;
}
function HydratedTitle({ request, titleComponent: Title, ...props }) {
  const query = useQuery({
    queryKey: ['album-content-rating', request],
    queryFn: async ({ signal }) => {
      const response = await api.getPublic(request.path, {
        params: request.params,
        signal,
        timeout: 15000,
        suppressGlobalError: true,
      });
      return response.data?.data?.contentRating ?? null;
    },
    staleTime: 3600000,
    retry: false,
  });
  return <Title {...props} explicit={query.data === 'EXPLICIT'} />;
}
// Like build60 useHomeExplicit: missing summary metadata is unknown, not CLEAN.
// Known metadata always wins; public album metadata is shared, never account data.
export default function AlbumContentTitle({
  item,
  titleComponent: Title = ContentTitle,
  ...props
}) {
  const client = useContext(QueryClientContext);
  const known = item?.contentRating ?? item?.albumContentRating;
  const request = known == null ? albumRatingRequest(item) : null;
  if (known != null || !request || !client)
    return <Title {...props} explicit={known === 'EXPLICIT'} />;
  return <HydratedTitle {...props} request={request} titleComponent={Title} />;
}
